import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const faqs = [{
    q: '¿Esto reemplaza a un psicólogo?',
    a: 'No, es una herramienta de primeros auxilios para el momento de la crisis.'
  }, {
    q: '¿Funciona si mi hijo no cree en esto?',
    a: "Sí, porque es una respuesta biológica, no requiere 'fe' para que el oxígeno regrese a su ritmo normal."
  }, {
    q: '¿Es difícil de aprender?',
    a: 'No, está escrito en lenguaje sencillo para adolescentes estresados.'
  }, {
    q: '¿Puedo leerlo durante el ataque?',
    a: 'Sí, está diseñado con párrafos cortos y listas rápidas para lectura de emergencia.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-20 md:py-28 px-6" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <FadeIn data-id="element-31">
          <h2 className="text-3xl md:text-5xl font-serif text-slate-900 text-center mb-12" data-id="element-32">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-34">
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-35">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" data-id="element-36">
                  <span className="text-lg md:text-xl font-bold text-slate-800 pr-4" data-id="element-37">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-sage-dark flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-38" />
                </button>
                <AnimatePresence data-id="element-39">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-40">
                      <div className="px-6 pb-5 text-slate-600 text-lg border-t border-slate-100 pt-4" data-id="element-41">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}